import {
  Delete,
  LayoutDashboard,
  LogOut,
  MenuIcon,
  Network,
  NotepadText,
  UploadCloud,
  Users2,
} from "lucide-react";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import "../styles/SideBar.module.css"; // Ensure styles reflect these changes

function SideBar() {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  useEffect(() => {
    const loggedin = localStorage.getItem("loggedin");
    if (!loggedin) {
      navigate("/");
    } 
    // eslint-disable-next-line
  }, []);
  const handleLogout = () => {
    // Remove from localStorage
    localStorage.removeItem("loggedin");
    localStorage.removeItem("usertype");
    localStorage.removeItem("id");
    localStorage.removeItem("name");
    localStorage.removeItem("email");
    // Navigate immediately after logout
    navigate("/");
  };
  return (
    <div
      className={`sidebar ${isCollapsed ? "collapsed" : ""}`}
      style={{ fontSize: "100%", cursor: "pointer", color: "rgba(0,0,0,0.6)" }}
    >
      {/* Sidebar Header */}
      <div
          style={{
            marginBottom: 0,
            textAlign: "center",
            backgroundColor: "#fff",
          }}
        >
          <div
            style={{
              fontSize: "100%",
              fontWeight: "bold",
              marginBottom: 0,
              marginTop: 0,
            }}
          >
            <img
              src={require("../img/logo1.png")}
              alt="logo"
              className="logo"
              style={{ width: isCollapsed?60:110 }}
            />
          </div>
        </div>
      <div className="d-flex flex-row align-items-center justify-content-between p-4 pt-2">
        {/* Conditionally show the "otrip" title if sidebar is not collapsed */}
        {!isCollapsed && (
          <h4>
            <i></i>
          </h4>
        )}
     
          {!isCollapsed ? <Delete onClick={() => setIsCollapsed(!isCollapsed)} size={23}  style={{ color: "#000" }}  />:
          <MenuIcon size={23} onClick={() => setIsCollapsed(!isCollapsed)}  style={{ color: "#000" }}  />
}

      </div>
      
      {/* Sidebar Links */}
      <div className="mt-0 text-center">
        {localStorage.getItem("usertype") === "user" ? null : (
          <div
            className="sidebar-item mb-3"
            onClick={() => navigate("/dashboard")}
          >
            <LayoutDashboard size={23} style={{ color: "#000" }} />
            {/* Only show text if sidebar is not collapsed */}
            <div
              style={{
                width: "70%",
                textAlign: "left",
                textOverflow:"clip",
                background:
                  "linear-gradient(45deg, #000, #000, #000, #000)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              {!isCollapsed && <span>{t("Dashboard")}</span>}
            </div>
          </div>
        )}
        {localStorage.getItem("usertype") === "user" ? (
          <div
            className="sidebar-item mb-3"
            onClick={() => navigate("/management")}
            style={{
              background:
                "linear-gradient(45deg, #000, #000, #000, #000)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            <LayoutDashboard size={23} style={{ color: "#000" }} />
            <div style={{ width: "70%", textAlign: "left", textOverflow:"clip",
 }}>
              {!isCollapsed && <span>{t("Dashboard")}</span>}
            </div>
          </div>
        ) : localStorage.getItem("usertype") === "technician" ? (
          <div
            className="sidebar-item mb-3"
            style={{
              background:
                "linear-gradient(45deg, #000, #000, #000, #000)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
            onClick={() => navigate("/management")}
          >
            <Users2 size={23} style={{ color: "#000" }} />

            <div style={{ width: "70%", textAlign: "left",textOverflow:"clip", }}>
              {!isCollapsed && <span>{t("Management")}</span>}
            </div>
          </div>
        ) : (
          <div
            className="sidebar-item mb-3"
            style={{
              background:
                "linear-gradient(45deg, #000, #000, #000, #000)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
            onClick={() => navigate("/management")}
          >
            <Users2 size={23} style={{ color: "#000" }} />

            <div style={{ width: "70%", textAlign: "left",textOverflow:"clip", }}>
              {!isCollapsed && <span>{t("Management")}</span>}
            </div>
          </div>
        )}

        {localStorage.getItem("usertype") === "user" ? null : (
          <div
            className="sidebar-item mb-3"
            style={{
              background:
                "linear-gradient(45deg, #000, #000, #000, #000)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
            onClick={() => navigate("/devices")}
          >
            <Network size={23} style={{ color: "#000" }} />

            <div style={{ width: "70%", textAlign: "left" }}>
              {!isCollapsed && <span>{t("Devices")}</span>}
            </div>
          </div>
        )}
        {localStorage.getItem("usertype") === "user" ? null : (
          <div
            className="sidebar-item mb-3"
            style={{
              background:
                "linear-gradient(45deg, #000, #000, #000, #000)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
            onClick={() => navigate("/cloud")}
          >
            <UploadCloud size={23} style={{ color: "#000" }} />

            <div style={{ width: "70%", textAlign: "left" }}>
              {!isCollapsed && <span>{t("OTA")}</span>}
            </div>
          </div>
        )}
  {localStorage.getItem("usertype") === "admin" || localStorage.getItem("usertype") === "sitemanager" ?(
          <div
            className="sidebar-item mb-3"
            style={{
              background:
                "linear-gradient(45deg, #000, #000, #000, #000)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
            onClick={() => navigate("/report")}
          >
            <NotepadText size={23} style={{ color: "#000" }} />

            <div style={{ width: "70%", textAlign: "left" }}>
              {!isCollapsed && <span>{t("Motor Report")}</span>}
            </div>
          </div>
        ):null}
        <div
          className="sidebar-item mb-3"
          style={{
            position: "absolute",
            bottom: "0px",
          }}
          onClick={() => {
            handleLogout();
          }}
        >
          <LogOut size={23} style={{ color: "#000" }} />

          <div
            style={{
              width: "70%",
              textAlign: "left",
              background:
                "linear-gradient(45deg, #000, #000, #000, #000)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            {!isCollapsed && <span>{t("Logout")}</span>}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SideBar;
